import { SxProps } from '@mui/system';
import { Note } from 'sr-types/lib/search/v1/graphql';
import { ProductionTypeSuperset } from '../helpers/productionApi';

export type ProductionCardViewProps = {
    viewState: ProductionTypeSuperset;
    onEdit?: () => void;
    setViewState?: (production: ProductionTypeSuperset) => void;
    isSaving?: boolean;
    isReadOnly?: boolean;
    enableSelectItem?: boolean;
    statusNote?: {
        enableCurrentNote?: boolean;
        onCurrentNoteClick?: (
            row: ProductionTypeSuperset,
            panelId: string,
            note: Note,
            isStatusNoteAction?: boolean
        ) => void;
        onStatusNoteDeleted?: (noteId: string, productionId: string) => void;
        onStatusNoteChanged?: (note: Note | null, productionId: string) => void;
    };
    sidePanelView?: boolean;
    sx?: SxProps;
    defaultCollapsed?: boolean;
};

export type RoleGroup<T> = { role: string; items: T[] };

/**
 * Groups items by production role so each role appears once with all of its items.
 * Items without roles are grouped under `noRoleLabel`.
 */
export const groupItemsByRole = <T>(
    items: T[],
    getRoles: (item: T) => string[] | null | undefined,
    noRoleLabel: string
): RoleGroup<T>[] => {
    const groups = new Map<string, T[]>();

    items.forEach((item) => {
        const roles = [...new Set((getRoles(item) || []).map((role) => role.trim()).filter(Boolean))];
        (roles.length ? roles : [noRoleLabel]).forEach((role) => {
            const existing = groups.get(role) || [];
            if (!existing.includes(item)) existing.push(item);
            groups.set(role, existing);
        });
    });

    const result = Array.from(groups, ([role, groupItems]) => ({ role, items: groupItems }));
    return result;
};
